import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { now } from 'moment';
import * as moment from 'moment';

import { Iterable } from 'capacitor-iterable';
import { AuthService } from 'src/app/shared/services/auth.service';
const iterable = new Iterable();

@Injectable({
    providedIn: 'root'
})
export class IterableService {
    constructor(private auth: AuthService, private platform: Platform) {}

    public logEvent(name: string, data: any) {
        if (this.checkPlatform()) {
            const constData = {
                userUid: this.auth.currentAuth.user.uid,
                time: moment(now()).toDate().toString()
            };
            try {
                iterable.trackEvent({
                    name,
                    data: { ...constData, ...data }
                });
            } catch (error) {
                console.error(error);
            }
        }
    }

    public async registerUser(): Promise<boolean> {
        if (this.checkPlatform() && this.auth.currentAuth.user.uid) {
            try {
                await iterable.setUserId({ userId: this.auth.currentAuth.user.uid });
                await iterable.setEmail({ email: this.auth.currentAuth.user.email });
                return true;
            } catch (error) {
                console.error(error);
                return false;
            }
        }
        return false;
    }

    public logout() {
        if (this.checkPlatform()) {
            try {
                iterable.unregisterPush();
            } catch (error) {
                console.error(error);
            }
        }
    }

    public refreshToken(token: string) {
        if (this.checkPlatform()) {
            try {
                iterable.refreshToken({ token });
            } catch (error) {
                console.error(error);
            }
        }
    }

    private checkPlatform() {
        return this.platform.is('capacitor') || this.platform.is('cordova');
    }

    public openInbox() {
        iterable.getNumberOfUnreadMessages().then((num) => {
            console.error(JSON.stringify(num));
        });
        iterable.showInbox();
    }

    public async getNumberOfUnreadMessages() {
        return (await iterable.getNumberOfUnreadMessages()).unreadMessages;
    }
}
